import { useRef } from 'react';

export function useDebouncedCallback<T extends (...args: any[]) => void>(
  callback: T | undefined,
  delay: number | undefined
): T | undefined {
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  if (!callback) return undefined;

  return ((...args: Parameters<T>) => {
    if (timeout.current) clearTimeout(timeout.current);

    if (delay === undefined) {
      callback?.(...args);
    } else {
      timeout.current = setTimeout(() => {
        callback?.(...args);
      }, delay);
    }
  }) as T;
}
